export { default } from './Pagination'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Pagination/index.js